'use client';

import Image from '@/components/Image';
import WapOnly from '@/components/Responsive/WapOnly';
import WebOnly from '@/components/Responsive/WebOnly';
import Link from 'next/link';

const PhotochromicLenses = () => {
  return (
    <>
      <WebOnly>
        <div className="bg-white w-[80%] mx-auto pb-[134px]">
          <Image
            className="w-full"
            width={800}
            height={600}
            src="/static-page/guide-tips/photochromic-lenses/top-banner.png"
            alt=""
          />

          <div className="mt-[60px] mb-[60px] text-[36px] font-bb">
            Selbsttönende Brillengläser - Eine Brille, viele Verwendungen
          </div>
          <div className="my-[28px] text-[22px] font-bb">
            Zeelool Selbsttönende Brillengläser in verschiedenen Farben im Verfärbungsprozess
          </div>
          <div className="text-[16px] leading-[24px]">
            Sind Sie sich nicht sicher über die tatsächliche Farbe und den Farbwechselprozess von
            Zeelool Selbsttönende Brillengläser? Dieses Video hilft Ihnen weiter! <br />
            <span className="text-[#666666]">
              Tipp: Die Farbtöne der Brillengläser hängen von der UV-Intensität, der Temperatur und
              der Luftfeuchtigkeit im Freien ab. Es wird anders sein. Das Video dient nur zur
              Information.
            </span>
          </div>

          <div className="my-[30px] mb-[55px]">
            <video
              className="w-full"
              src="https://common.xmslol.com/video/zeelool-de/photochromic-lenses.mp4"
              controls
            />
          </div>

          <div className="my-[28px] text-[22px] font-bb">
            Eigenschaften von Selbsttönende Brillengläser
          </div>
          <div className="text-[16px] leading-[24px]">
            Selbsttönende Brillengläser passen ihre Farbe automatisch an die Intensität der
            UV-Strahlen an und bieten so den bestmöglichen UV-Schutz für die Augen. Funktioniert
            sowohl als Korrektionsbrillen als auch als Sonnenbrillen. In Innenräumen sehen sie
            genauso aus wie normale klare Brillengläser und können als Korrektionsbrillen verwendet
            werden. Das Brillengläser verdunkelt sich automatisch, wenn Sie einen hell beleuchteten
            Bereich betreten. Zu dieser Zeit hat es UV-Schutz wie eine Sonnenbrille, so dass die
            Sonne nicht mehr blendet!
          </div>

          <div className="flex my-[60px] mb-[80px] bg-[#f5f5f5]">
            {/* 左侧可伸缩内容，允许换行并不挤压右侧 */}
            <div className="flex-1 min-w-0 pt-[50px] pr-[105px] pb-0 pl-[40px]">
              <div className="mb-[28px] text-[22px] font-bb">
                Anwendungsszenarien für Selbsttönende Brillen
              </div>
              <div className="text-[16px] leading-[24px]">
                Für drinnen und draußen geeignet! Es wechselt automatisch zwischen getönten und
                klaren Gläsern, je nach Einsatzort, und löst so das Problem, die Brille unterwegs
                wechseln zu müssen. Selbsttönende Brillengläser können auch als Korrektionsbrillen
                verwendet werden und sind stapelbar! Wenn Sie sich eine Brille wünschen, die Sie vor
                UV-Strahlen schützt und Ihre Sicht reguliert, können Sie sie sowohl drinnen als auch
                draußen verwenden. Wählen Sie einfach Selbsttönende Brillengläser aus dem Abschnitt
                Gläsertyp auswählen auf der Rezept-Seite!
              </div>
              <br />
              <div className="text-[14px] leading-[24px]">
                Das Bild ist nur ein Beispiel für die Selbsttönenden Brillengläser in Bernstein. Die
                tatsächliche Tiefe der Farbveränderung wird durch die Intensität des UV-Lichts
                bestimmt.
              </div>
            </div>

            {/* 右侧固定尺寸，不被压缩，父容器 relative 以配合 Image fill */}
            <div className="flex-none flex-shrink-0 relative w-[453px] h-[394px]">
              <Image
                src="/static-page/guide-tips/photochromic-lenses/mid-box-right.png"
                alt=""
                fill
                style={{ objectFit: 'cover' }}
                className="block"
              />
            </div>
          </div>

          <div className="my-[28px] text-[22px]">
            Selbsttönende Brillengläser vs. Normale Sonnenbrillengläser vs. Polarisierende
            Sonnenbrillengläser
          </div>
          <div className="text-[16px] leading-[24px]">
            Selbsttönende Brillengläser: Indoor ist es transparent, Outdoor dunkelt die Farbe nach.
            Filtert schädliche UV-Strahlen heraus. <br />
            Normale Sonnenbrillengläser: Gleiche Farbe für drinnen und draußen, filtert schädliche
            UV-Strahlen.
            <br />
            Polarisierende Sonnenbrillengläser: Die Farben des In- und Outdoor-Bereichs sind
            identisch. Es filtert schädliche UV-Strahlen und schützt auch vor Blendung.
            <br />
          </div>

          <div className="flex justify-between my-[28px] mb-[35px]">
            <div className="w-[28.8%]">
              <Image
                className="block w-full"
                width={283}
                height={184}
                src="/static-page/guide-tips/photochromic-lenses/photochromic-lenses.png"
                alt=""
              />
              <span className="block mt-[20px] text-center">Selbsttönende Brillengläser</span>
            </div>
            <div className="w-[28.8%]">
              <Image
                className="block w-full"
                width={283}
                height={184}
                src="/static-page/guide-tips/photochromic-lenses/normal-sunglasses.png"
                alt=""
              />
              <span className="block mt-[20px] text-center">Normale Sonnenbrillengläser</span>
            </div>
            <div className="w-[28.8%]">
              <Image
                className="block w-full"
                width={283}
                height={184}
                src="/static-page/guide-tips/photochromic-lenses/polarized-sunglasses.png"
                alt=""
              />
              <span className="block mt-[20px] text-center">
                Polarisierende Sonnenbrillengläser
              </span>
            </div>
          </div>

          <div className="mb-[75px] text-[16px]">
            Erfahren Sie hier mehr über Polarisierende Sonnenbrillengläser:{' '}
            <Link className="underline" href="/guide-tips/polarized-lenses">
              Polarisierende Sonnenbrillengläser
            </Link>
          </div>

          <div className="my-[28px] text-[22px]">Shop für Zeelool Selbsttönende Brillen</div>
          <div className="text-[16px] leading-[24px]">
            Alle Rahmen von Zeelool (800+ Designermodelle) können mit Selbsttönende Brillengläser
            ausgestattet werden, unabhängig davon, ob Sie Ihre Sehstärke durch eine Überlagerung
            korrigieren möchten oder nicht. Es bietet einen hervorragenden UV-Schutz für Ihre Augen
            und sorgt für klare Sicht! Hält das Sonnenlicht von den Augen fern! Eine Brille für den
            In- und Outdoor-Bereich, die einfach perfekt ist!
          </div>
          <Link
            className="flex items-center justify-center w-[220px] h-[50px] mt-[30px] bg-[#463ae8] text-white text-[16px]"
            href="/"
          >
            Jetzt kaufen
          </Link>
        </div>
      </WebOnly>
      <WapOnly>
        <div className="bg-white px-[15px] pt-0 pb-0">
          {/* 顶部大图 */}
          <Image
            className="w-full"
            width={750}
            height={380}
            src="/static-page/guide-tips/photochromic-lenses/top-banner.png"
            alt=""
          />

          {/* 标题与说明 */}
          <div className="mt-[24px] mb-[40px] text-[22px] font-bb">
            Selbsttönende Brillengläser - Eine Brille, viele Verwendungen
          </div>
          <div className="my-[29px] text-[18px] font-bb">
            Zeelool Selbsttönende Brillengläser in verschiedenen Farben im Verfärbungsprozess
          </div>
          <div className="text-[14px] leading-[22px] text-[#333333]">
            Sind Sie sich nicht sicher über die tatsächliche Farbe und den Farbwechselprozess von
            Zeelool Selbsttönende Brillengläser? Dieses Video hilft Ihnen weiter! <br />
            <span className="text-[#666666] block mt-[10px]">
              Tipp: Die Farbtöne der Brillengläser hängen von der UV-Intensität, der Temperatur und
              der Luftfeuchtigkeit im Freien ab. Es wird anders sein. Das Video dient nur zur
              Information.
            </span>
          </div>

          {/* 视频 */}
          <div className="mt-[22px] mb-[40px]">
            <video
              className="w-full"
              src="https://common.xmslol.com/video/zeelool-de/photochromic-lenses.mp4"
              controls
            />
          </div>

          {/* 特性说明 */}
          <div className="my-[40px] text-[18px] font-bb">
            Eigenschaften von Selbsttönende Brillengläser
          </div>
          <div className="text-[14px] leading-[22px] text-[#333333]">
            Selbsttönende Brillengläser passen ihre Farbe automatisch an die Intensität der
            UV-Strahlen an und bieten so den bestmöglichen UV-Schutz für die Augen. Funktioniert
            sowohl als Korrektionsbrillen als auch als Sonnenbrillen. In Innenräumen sehen sie
            genauso aus wie normale klare Brillengläser und können als Korrektionsbrillen verwendet
            werden. Das Brillengläser verdunkelt sich automatisch, wenn Sie einen hell beleuchteten
            Bereich betreten. Zu dieser Zeit hat es UV-Schutz wie eine Sonnenbrille, so dass die
            Sonne nicht mehr blendet!
          </div>

          {/* 应用场景（上下排列） */}
          <div className="flex flex-col mt-0">
            <div className="w-full p-0">
              <div className="my-[40px] text-[18px] font-bb">
                Anwendungsszenarien für Selbsttönende Brillen
              </div>
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Für drinnen und draußen geeignet! Es wechselt automatisch zwischen getönten und
                klaren Gläsern, je nach Einsatzort, und löst so das Problem, die Brille unterwegs
                wechseln zu müssen. Selbsttönende Brillengläser können auch als Korrektionsbrillen
                verwendet werden und sind stapelbar! Wenn Sie sich eine Brille wünschen, die Sie vor
                UV-Strahlen schützt und Ihre Sicht reguliert, können Sie sie sowohl drinnen als auch
                draußen verwenden. Wählen Sie einfach Selbsttönende Brillengläser aus dem Abschnitt
                Gläsertyp auswählen auf der Rezept-Seite!
              </div>
              <br />
              <div className="text-[14px] leading-[22px] text-[#333333] mt-[10px]">
                Das Bild ist nur ein Beispiel für die Selbsttönenden Brillengläser in Bernstein. Die
                tatsächliche Tiefe der Farbveränderung wird durch die Intensität des UV-Lichts
                bestimmt.
              </div>
            </div>
            <div className="w-full mt-[20px]">
              <Image
                className="w-full"
                width={690}
                height={394}
                src="/static-page/guide-tips/photochromic-lenses/application-scenario.png"
                alt=""
              />
            </div>
          </div>

          {/* 对比说明（三段纵向） */}
          <div className="my-[40px] text-[18px] font-bb">
            Selbsttönende Brillengläser vs. Normale Sonnenbrillengläser vs. Polarisierende
            Sonnenbrillengläser
          </div>
          <div className="flex flex-col mb-0">
            <div className="w-full">
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Selbsttönende Brillengläser:
                <br />
                Indoor ist es transparent, Outdoor dunkelt die Farbe nach. Filtert schädliche
                UV-Strahlen heraus.
              </div>
              <Image
                className="w-full my-[16px] mb-[20px]"
                width={690}
                height={388}
                src="/static-page/guide-tips/photochromic-lenses/photochromic-lenses-comparison.png"
                alt=""
              />
            </div>
            <div className="w-full">
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Normale Sonnenbrillengläser:
                <br />
                Gleiche Farbe für drinnen und draußen, filtert schädliche UV-Strahlen.
              </div>
              <Image
                className="w-full my-[16px] mb-[20px]"
                width={690}
                height={388}
                src="/static-page/guide-tips/photochromic-lenses/normal-sunglasses-comparison.png"
                alt=""
              />
            </div>
            <div className="w-full">
              <div className="text-[14px] leading-[22px] text-[#333333]">
                Polarisierende Sonnenbrillengläser:
                <br />
                Die Farben des In- und Outdoor-Bereichs sind identisch. Es filtert schädliche
                UV-Strahlen und schützt auch vor Blendung.
              </div>
              <Image
                className="w-full my-[16px] mb-[20px]"
                width={690}
                height={388}
                src="/static-page/guide-tips/photochromic-lenses/polarized-lenses-comparison.png"
                alt=""
              />
            </div>
          </div>

          {/* 引导链接与购买按钮 */}
          <div className="mb-[40px] font-bb text-[16px]">
            Erfahren Sie hier mehr über Polarisierende Sonnenbrillengläser:
            <br />
            <Link className="underline" href="/guide-tips/polarized-lenses">
              Polarisierende Sonnenbrillengläser
            </Link>
          </div>

          <div className="my-[29px] text-[18px] font-bb">
            Shop für Zeelool Selbsttönende Brillen
          </div>
          <div className="text-[14px] leading-[22px] text-[#333333]">
            Alle Rahmen von Zeelool (800+ Designermodelle) können mit Selbsttönende Brillengläser
            ausgestattet werden, unabhängig davon, ob Sie Ihre Sehstärke durch eine Überlagerung
            korrigieren möchten oder nicht. Es bietet einen hervorragenden UV-Schutz für Ihre Augen
            und sorgt für klare Sicht! Hält das Sonnenlicht von den Augen fern! Eine Brille für den
            In- und Outdoor-Bereich, die einfach perfekt ist!
          </div>
          <Link
            className="flex items-center justify-center w-[140px] h-[35px] mt-[30px] bg-[#463ae8] text-white text-[14px] mb-[40px]"
            href="/"
          >
            Jetzt kaufen
          </Link>
        </div>
      </WapOnly>
    </>
  );
};

export default PhotochromicLenses;
